import React, { useEffect, useState } from 'react';
import './SupplierStyle.css';
import SupplierCard from './SupplierCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faUser } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import {getSupplier} from '../../redux/actions/Supplier/SupplierAction';

const SupplierDashboard = ({supplier, getSupplier}) => {

    const [supplierName, setSupplierName] = useState('');

    const params = useParams();
    useEffect(()=>{
        if(supplier && supplier.length === 0)
            getSupplier(params.supplierId);
    },[supplier]);

    useEffect(()=>{
        setSupplierName(supplier.supplierName);
    },[supplier]);

    return (
        <div className='Dashboard-main-div'>
            <div className='greeting'>
                <h1>Welcome {supplierName}!</h1>
            </div>
            <div className='line-Separator'></div>
            <div className='optionCards'>
                <SupplierCard details={[`/supplier/${params.supplierId}/productDetails`,<FontAwesomeIcon className='FntIcon' key={1} icon={faBoxOpen} />,'Products']}/>
                <SupplierCard details={[`/supplier/${params.supplierId}/updateProfile`,<FontAwesomeIcon className='FntIcon' key={2} icon={faUser} />,'Update Profile']}/>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    console.log(state.suppliers);
    return{supplier: state.suppliers};

};

const mapDispatchToProps = {
    getSupplier,
};

export default connect(mapStateToProps, mapDispatchToProps)(SupplierDashboard);